export default function cartItemTypes(cartItems) {
  const itemTypes = {};

  cartItems.forEach((item) => {
    if (item.properties?._is_swatch === "true") {
      itemTypes[item.properties._swatch_type] = true;
    } else {
      itemTypes.nonSwatch = true;
    }
  });

  return {
    ...itemTypes,
    mixed: Object.keys(itemTypes).length > 1,
  };
}
